function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#224084;}\n\t.st1{fill:url(#SVGID_1_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "surface1_4_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M26.8,33.5H7.5c-1.1,0-2-0.9-2-2v-4.7c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v4.7 c0,1.9,1.5,3.4,3.4,3.4h20c1.9,0,3.4-1.5,3.4-3.4V16.8c0-1.6-1.2-3-2.7-3.3v-3.2c0-5.6-5.1-10.2-10.7-10.2S6.9,4.7,6.9,10.3v3.2 c-1.5,0.3-2.7,1.7-2.7,3.3v3.2c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-3.2c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v14.6 c0,0.9-0.6,1.6-1.4,1.9L26.8,33.5z M11.9,13.4v-3.1c0-2.8,2.8-5.1,5.7-5.1s5.7,2.3,5.7,5.1v3.1H11.9z M24.5,13.4v-3.1 c0-3.6-3.4-6.5-7-6.5s-7,2.9-7,6.5v3.1H8.2v-3.1c0-4.9,4.5-8.8,9.3-8.8s9.3,3.9,9.3,8.8v3.1H24.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M27.5,35h-20c-2,0-3.6-1.6-3.6-3.6v-4.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v4.7c0,1,0.8,1.8,1.8,1.8 h19.3l1.3-0.1c0.7-0.3,1.2-1,1.2-1.7V16.8c0-1-0.8-1.8-1.8-1.8h-20c-1,0-1.8,0.8-1.8,1.8v3.2c0,0.5-0.4,0.9-0.9,0.9 S4,20.5,4,20.1v-3.2c0-1.6,1.1-3.1,2.7-3.5v-3C6.7,4.7,11.6,0,17.5,0c5.9,0,10.9,4.7,10.9,10.4v3c1.6,0.4,2.7,1.8,2.7,3.5v14.6 C31.1,33.4,29.5,35,27.5,35z M4.8,26.2c-0.3,0-0.5,0.2-0.5,0.5v4.7c0,1.8,1.4,3.2,3.2,3.2h20c1.8,0,3.2-1.4,3.2-3.2V16.8 c0-1.5-1.1-2.8-2.6-3.1l-0.2,0v-3.3c0-5.4-4.8-10-10.5-10S7.1,4.9,7.1,10.3v3.3l-0.2,0c-1.5,0.3-2.6,1.6-2.6,3.1v3.2 c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-3.2c0-1.2,1-2.2,2.2-2.2h20c1.2,0,2.2,1,2.2,2.2v14.6c0,0.9-0.6,1.8-1.5,2.1l0,0 l-1.4,0.1H7.5c-1.2,0-2.2-1-2.2-2.2v-4.7C5.3,26.4,5.1,26.2,4.8,26.2z M27,13.6h-2.7v-3.3C24.3,7,21.2,4,17.5,4s-6.8,2.9-6.8,6.3 v3.3H8v-3.3c0-4.8,4.4-9,9.5-9s9.5,4.2,9.5,9V13.6z M24.7,13.2h1.9v-2.9c0-4.6-4.3-8.6-9.1-8.6s-9.1,4-9.1,8.6v2.9h1.9v-2.9 c0-3.6,3.4-6.7,7.2-6.7s7.2,3.1,7.2,6.7V13.2z M23.4,13.6H11.7v-3.3c0-2.8,2.8-5.3,5.8-5.3c3.1,0,5.8,2.5,5.8,5.3V13.6z  M12.1,13.2H23v-2.9c0-2.6-2.6-5-5.5-5s-5.5,2.4-5.5,5V13.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.8,24.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5C4.5,24,4.6,24.1,4.8,24.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.8,24.3c-0.2,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.7c0.3-0.3,1-0.3,1.3,0 c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2-0.1,0.5-0.3,0.7C5.3,24.2,5.1,24.3,4.8,24.3z M4.8,22.8c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4c0.2,0.2,0.5,0.2,0.7,0c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1-0.1-0.3-0.2-0.4 C5.1,22.9,5,22.8,4.8,22.8z"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.5,18.3c-2,0-4.2,1.6-4.2,3.7c0,1.2,0.6,2.4,1.6,3v3.6c0,1.1,1.4,2,2.5,2c1.1,0,2.5-0.9,2.5-2V25 c1-0.7,1.6-1.8,1.6-3C21.7,20,19.5,18.3,17.5,18.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M17.5,18.3c-2,0-4.2,1.6-4.2,3.7c0,1.2,0.6,2.4,1.6,3v3.6c0,1.1,1.4,2,2.5,2c1.1,0,2.5-0.9,2.5-2V25 c1-0.7,1.6-1.8,1.6-3C21.7,20,19.5,18.3,17.5,18.3z"
});

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -20448.4863,
    y1: 1885.0249,
    x2: -20435.1426,
    y2: 1885.0249,
    gradientTransform: "matrix(0 -1 1 0 -1867.5186 -20417.2266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#223469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#10488A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#0257A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5164,
    style: {
      stopColor: "#0E8CCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    style: {
      stopColor: "#19C1F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7542,
    style: {
      stopColor: "#24C2EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    style: {
      stopColor: "#43C6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9288,
    style: {
      stopColor: "#74CCD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9CD1C4"
    }
  })), _ref5)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.b1e58e08.svg";
export { ForwardRef as ReactComponent };